import React from "react";
import { Globe, Handshake, DollarSign } from "lucide-react";

const AboutSection = () => {
  const items = [
    {
      icon: <Globe className="w-12 h-12 text-teal-600" />,
      title: "Who We Are",
      desc: "BookTrip4Me is your trusted travel partner—modern, simple, and built for travelers who want transparent prices and smooth bookings.",
    },
    {
      icon: <Handshake className="w-12 h-12 text-teal-500" />,
      title: "Our Approach",
      desc: "We partner with global carriers and use smart technology to deliver the best fares and a seamless booking experience.",
    },
    {
      icon: <DollarSign className="w-12 h-12 text-teal-700" />,
      title: "Why Choose Us",
      desc: "Great deals, 24/7 customer support, and a travel platform built around ease and comfort.",
    },
  ];

  return (
    <section className="py-16 px-6 bg-gradient-to-br from-[#E8F9F6] via-[#F5FCFB] to-white">
      
      {/* HEADER */}
      <div className="text-center mb-12">
        <h2 className="text-4xl font-extrabold text-gray-900 mb-3">
          About <span className="text-teal-600">BookTrip4Me</span>
        </h2>
        <p className="text-gray-600 max-w-3xl mx-auto text-lg">
          We’re here to make travel simple, transparent, and memorable—offering curated flight deals and a premium booking experience.
        </p>
      </div>

      {/* FEATURES */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {items.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-md p-8 text-center transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
          >
            <div className="flex justify-center mb-4">{item.icon}</div>
            <h3 className="text-xl font-bold mb-2 text-gray-800">{item.title}</h3>
            <p className="text-gray-600">{item.desc}</p>
          </div>
        ))}
      </div>

      {/* CALL BUTTON */}
      <div className="text-center mt-12">
        <a href="tel:+18887112909">
          <button className="bg-teal-500 text-white font-semibold px-8 py-3 rounded-full shadow-md hover:bg-teal-600 transition-all duration-300 hover:shadow-lg">
            📞 Call to Book Your Trip
          </button>
        </a>
      </div>

    </section>
  );
};

export default AboutSection;
